import { getNow } from './datetime';
import { getTimezone } from '../../timezone';

export const REPORT_TABS = ['day', 'month', 'form'];
const REPORT_DATETIME_FORMAT = 'YYYY/MM/DD';
const REPORT_MONTH_FORMAT = 'YYYY/MM';

export const REPORT_TAB_INIT_VALUES = {
    day: {
        id: 'day',
        label: {
            from: 'Start Date',
            to: 'End Date',
        },
        menuItem: 'By Day',
        calendarType: 'date',
        maxDate: {
            from: getNow({ format: REPORT_DATETIME_FORMAT, timezone: getTimezone() }),
            to: getNow({ format: REPORT_DATETIME_FORMAT, timezone: getTimezone() }),
        },
        withinDuration: {
            durationLength: 31,
            durationType: 'days',
        },
    },
    month: {
        id: 'month',
        label: {
            from: 'From Month',
            to: 'To Month',
        },
        menuItem: 'By Month',
        calendarType: 'monthYear',
        maxDate: {
            from: getNow({ format: REPORT_MONTH_FORMAT, timezone: getTimezone() }),
            to: getNow({ format: REPORT_MONTH_FORMAT, timezone: getTimezone() }),
        },
        withinDuration: {
            durationLength: 12,
            durationType: 'months',
        },
    },
    form: {
        id: 'form',
        menuItem: 'By Form',
    },
};
